import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { accountTranslations } from '../helpers/translations'

export const FormOnBoardingButtons = ({ handleSkip, disabled }) => {
  return (
    <div>
      <div className={'my-8 border border-solid border-neutrals-secondary-grey opacity-50'}></div>
      <OnBoardingButtons handleSkip={handleSkip} disabled={disabled} />
    </div>
  )
}

const OnBoardingButtons = ({ handleSkip, disabled }) => {
  const context = useMobileFiltersContext()
  const { currentState } = context.config

  if (currentState === ON_BOARDING_STATES.CONFIRMATION) {
    return <button className={'btn btn-lg btn-solid-accent w-full justify-center'}>{accountTranslations.onboarding.step_5.submit}</button>
  }

  if (currentState > ON_BOARDING_STATES.AVATAR) {
    return (
      <div className={'flex flex-row gap-4'}>
        <button
          type="button"
          className={'btn btn-lg btn-outline-black relative w-full justify-center'}
          onClick={handleSkip}
        >
          Skip
        </button>
        <button data-role="submit" className={'btn btn-lg btn-solid-black w-full justify-center'} disabled={disabled}>
          Continue
        </button>
      </div>
    )
  }
  return (
    <button data-role="submit" className={'btn btn-lg btn-solid-black w-full justify-center'} disabled={disabled}>
      Continue
    </button>
  )
}
